import MobileInput from './mobile-input'

export default {
    install: function(Vue) {
        Vue.component('MobileInput', MobileInput)
    }
}